import { getFeaturedReferralProgram } from '../services/ReferralService';

// One promise per page load: the endpoint is rate-limited, and every slot shares the answer.
let pending = null;

/** The featured referral program's promo `copy`, or `{}` on any failure. Never rejects. */
export const loadReferralAdCopy = () => {
  if (!pending) {
    pending = Promise.resolve()
      .then(() => getFeaturedReferralProgram())
      .then((response) => response?.data?.program?.copy ?? {})
      .catch(() => ({}));
  }
  return pending;
};

export const resetReferralAdCopyForTest = () => {
  pending = null;
};
